import httpClient from "Api/httpClient";

const END_POINT = "/people";

const getPeople = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getPerson = (people_id) => {
    if (!people_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + people_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printPerson = (people_id) => {
    if (!people_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?people_id=" + people_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createPeople = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updatePeople = (payload, people_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + people_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

/*const updatePeoplePhoto = (payload, people_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + people_id + "/photo";
    return httpClient.patch(UPDATE_END_POINT, body);
};*/

const deletePeople = (people_id) => {
    const DELETE_END_POINT = END_POINT + "/" + people_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const updateUserDeviceFilterList = (payload) => {
    const UPDATE_END_POINT = "/users/" + payload.body.user_id + "/company/" + payload.body.company_id + "/limit_devices";
    delete payload.body.company_id;
    delete payload.body.user_id;
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(UPDATE_END_POINT, body);
};
const updateUserTagFilterList = (payload) => {
    const UPDATE_END_POINT = "/users/" + payload.body.user_id + "/company/" + payload.body.company_id + "/tags";
    delete payload.body.company_id;
    delete payload.body.user_id;
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.patch(UPDATE_END_POINT, body);
};

const requestLoginAsUser = (id) => {
    const GET_URL = "/authenticate/login_as/" + id;
    return httpClient.get(GET_URL);
};

const updatePeopleEmail = (payload, people_id, email_id = null) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    let UPDATE_END_POINT = END_POINT + "/" + people_id + "/emails";
    if (email_id) {
        UPDATE_END_POINT = UPDATE_END_POINT + "/" + email_id;
    }
    return httpClient.patch(UPDATE_END_POINT, body);
};

const addPeopleEmail = (payload, people_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + people_id + "/emails";
    return httpClient.post(UPDATE_END_POINT, body);
};

const removePeopleEmail = (people_id, email_id) => {
    const DELETE_END_POINT = END_POINT + "/" + people_id + "/emails/" + email_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export {
    getPeople,
    getPerson,
    printPerson,
    createPeople,
    updatePeople,
    deletePeople,
    updateUserDeviceFilterList,
    updateUserTagFilterList,
    requestLoginAsUser,
    updatePeopleEmail,
    addPeopleEmail,
    removePeopleEmail,
};
